/*global google*/

import { useEffect, useRef } from 'react';

import { getPlaceLongName } from './placeOrderSlice';

export const toLocation = (place) => ({
  address: `${place.name}, ${place.formatted_address}`,
  coordinate: {
    latitude: place.geometry.location.lat(),
    longitude: place.geometry.location.lng(),
  },
  street: getPlaceLongName(place.address_components, "street_address"),
  apartment: getPlaceLongName(place.address_components, "street_address"),
  state: getPlaceLongName(place.address_components, "administrative_area_level_1"),
  postalCode: getPlaceLongName(place.address_components, "postal_code"),
  city: getPlaceLongName(place.address_components, "locality"),
  country: getPlaceLongName(place.address_components, "country")
});

export const useAddressAutocomplete = (elementId, onSelect) => {
  const handler = useRef(onSelect);
  handler.current = onSelect;

  const boundNode = useRef(null);

  useEffect(() => {
    const input = document.getElementById(elementId);
    if (!input || boundNode.current === input) return;
    boundNode.current = input;

    const autocomplete = new google.maps.places.Autocomplete(input, {
      types: ["geocode", "establishment"],
      componentRestrictions: { country: ["my", "sg"] }
    });

    google.maps.event.addListener(autocomplete, "place_changed", () => {
      const place = autocomplete.getPlace();
      if (place) handler.current(place);
    });
  });
}
